// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+qk8z","loader__circle":"Loader_loader__circle__rrnPk","spin":"Loader_spin__ItFX1","bg":"Loader_bg__Fl8kl"};